// Refreshes unified items list when items are added/removed via Turbo Streams
//
// Can be used in two ways:
// 1. Attached to a persistent element to listen for refresh events
// 2. Appended via Turbo Stream with trigger=true to immediately refresh

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    refreshOnConnect: Boolean
  }

  connect() {
    if (this.refreshOnConnectValue) {
      this.refresh()
      this.element.remove()
      return
    }

    this.boundRefresh = this.refresh.bind(this)
    document.addEventListener('unified-item:removed', this.boundRefresh)
  }

  disconnect() {
    if (this.boundRefresh) {
      document.removeEventListener('unified-item:removed', this.boundRefresh)
    }
  }

  async refresh() {
    // Small delay to ensure database transaction has committed
    await new Promise((resolve) => setTimeout(resolve, 100))

    try {
      const response = await fetch('/business-pulse/refresh-counts', {
        headers: { Accept: 'text/vnd.turbo-stream.html' }
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error('Error refreshing unified items:', error)
    }
  }
}
